import { render } from "./StudentStudyLibSelectedTable.vue?vue&type=template&id=50d1db2f&scoped=true"
import script from "./StudentStudyLibSelectedTable.vue?vue&type=script&lang=js"
export * from "./StudentStudyLibSelectedTable.vue?vue&type=script&lang=js"

import "./StudentStudyLibSelectedTable.vue?vue&type=style&index=0&id=50d1db2f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d1db2f"]])

export default __exports__